export default {
  data() {
    return {
      current: null
    }
  },
  methods: {
    select(data) {
      this.current = data;
    },
    getSelectedCellClassName({row}) {
      let cellClassName = '';
      if (this.current && this.current[this.key] === row[this.key]) {
        cellClassName += ' currentAccess ';
      }
      return cellClassName;
    },
  },
  watch: {
    current: {
      deep: true,
      handler(value) {
        this.$emit('current-change', value);
      }
    }
  }
}